export default __webpack_public_path__ + "static/media/logo-app-store-light.25ac20a4.svg";